export const hasKey = (obj: AnyObject, key: string) => key in obj;